import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import clsx from 'clsx';
import { useLayout } from '../layout/core';
import { DrawerComponent } from '../../_flexCharge/assets/ts/components';

const Content = ({ children }: {children: React.ReactElement}): React.ReactElement => {
	const { classes } = useLayout();
	const location = useLocation();
	useEffect(() => {
		DrawerComponent.hideAll();
	}, [location]);

	return (
		<div id="kt_content_container" className={clsx(classes.contentContainer.join(' '))} style={{ position: 'relative' }}>
			{children}
		</div>
	);
};

export { Content };
